import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import { useSelector, useDispatch } from '../../../../../redux/store';
import { setAdditionToCartBadge, addItemsToCart } from '../../../../../redux/slices/orderSheet';
import { getCartInfoItemQty } from '../ordersheetUtils';
import { AwaitButton } from '../../../../../reusable-components/await-button';
import OrderOptions from './OrderOptions';
import CartTotalBox from './CartTotalBox';
import { ShopCartContext, ShopDataContext } from '../_ShopViewContext';

export default function CategoryNavbar() {
  const dispatch = useDispatch();
  const { facilityId = '' } = useParams();
  const { data: { cartInfo } } = useSelector((state) => state.orderSheet);
  const urlParams = new URLSearchParams(window.location.search);
  const categoryId = urlParams.get('categoryId');
  const resetQuantity = (added) => {
    dispatch(setAdditionToCartBadge(added));
  };
  const { cart: cartData } = useContext(ShopCartContext);
  const { data } = useContext(ShopDataContext);

  const getCartWithDiffs = () => 
    Object.keys(cartData).map((cartDataId) => {
      const dataItem = data.find((d) => d.id.toString() === cartDataId);
      if(!dataItem) return null;
      const cartInfoItemQty = getCartInfoItemQty(dataItem, categoryId, cartInfo);
      return {
        ...dataItem,
        agoraCategoryId: dataItem.displayCategory.id,
        agoraSubcategoryId: dataItem.displaySubcategory.id,
        quantity: cartData[cartDataId] - cartInfoItemQty,
        uomType: dataItem?.productDetails[0]?.uomType
      };
    }).filter(v => v !== null);
  
  const cartWithDiffs = getCartWithDiffs().filter((item) => item?.quantity !== 0);

  const addCart = () => {
    dispatch(addItemsToCart(cartWithDiffs, facilityId, categoryId));
    resetQuantity(cartWithDiffs.reduce((a, b) => a + b.quantity, 0));
  };

  return (
    <Grid container direction="row" alignItems="center" justifyContent="space-between">
      <Grid item>
        <OrderOptions />
      </Grid>
      <Grid item>
        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
          {cartWithDiffs.length > 0 ? (
            <>
              <Grid item>
                <Box sx={{ textAlign: 'right' }}>
                  <CartTotalBox />
                </Box>
              </Grid>
              <Grid item>
                <AwaitButton
                  onClick={addCart}
                  variant="outlined"
                  color="info"
                  sx={{
                    mr: 1,
                  }}
                >
                  Update cart
                </AwaitButton>
              </Grid>{' '}
            </>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
}
